module.exports = __webpack_public_path__ + "static/media/2019-02-04-01.e391a8e7.jpg";